const GAP = 12;
const MIN_POPUP_HEIGHT = 48;

export const getViewportPopupLayout = (element) => {
  if (!element || typeof window === 'undefined') {
    return {
      placement: 'bottomLeft',
      maxHeight: 320,
    };
  }

  const rect = element.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom - GAP;
  const spaceAbove = rect.top - GAP;
  const openUp = spaceAbove > spaceBelow;
  const available = Math.max(0, openUp ? spaceAbove : spaceBelow);
  const viewportCap = Math.max(window.innerHeight - GAP * 2, MIN_POPUP_HEIGHT);

  return {
    placement: openUp ? 'topLeft' : 'bottomLeft',
    maxHeight: Math.min(Math.max(available, MIN_POPUP_HEIGHT), viewportCap),
  };
};
